module.exports = __webpack_public_path__ + "media/headerVideo.9a0b7077.mp4";